import { BaseModal } from "../BaseModal";

export type PptImportSubmissionStatus = "consent" | "submitting" | "success" | "error";

const TITLE_BY_STATUS: Record<PptImportSubmissionStatus, string> = {
  consent: "Help us improve PowerPoint imports",
  submitting: "Help us improve PowerPoint imports",
  success: "File submitted",
  error: "Submission failed",
};

interface PptImportConsentModalProps {
  errorMessage?: string;
  fileName: string;
  open: boolean;
  status: PptImportSubmissionStatus;
  submissionId?: string;
  onAccept: () => void;
  onDecline: () => void;
}

const PptImportConsentModal = ({
  errorMessage,
  fileName,
  open,
  status,
  submissionId,
  onAccept,
  onDecline,
}: PptImportConsentModalProps) => {
  const isSubmitting = status === "submitting";
  const isSuccess = status === "success";
  const isError = status === "error";

  const title = TITLE_BY_STATUS[status];
  const confirmLabel = isError ? "Try Again" : "Send file";

  const actions = isSuccess ? (
    <button type="button" className="cpat-button cpat-button--label" onClick={onDecline}>
      Close
    </button>
  ) : (
    <>
      {!isSubmitting && (
        <button type="button" className="cpat-button cpat-button--label cpat-button--reverse" onClick={onDecline}>
          No, thanks
        </button>
      )}
      <button type="button" className="cpat-button cpat-button--label" onClick={onAccept} disabled={isSubmitting}>
        {isSubmitting ? "Sending..." : confirmLabel}
      </button>
    </>
  );

  return (
    <BaseModal
      open={open}
      title={title}
      onClose={isSubmitting ? undefined : onDecline}
      slots={{ bottomActions: actions }}
    >
      {status === "consent" && (
        <p>
          We couldn&apos;t import <strong>{fileName}</strong>. Would you like to send a copy to CPAT? Our team will
          store and review it to understand what caused the import to fail.
        </p>
      )}
      {isSubmitting && <output>Sending {fileName} for investigation...</output>}
      {isSuccess && (
        <output>
          Thank you. The PowerPoint file was submitted for investigation.
          {submissionId && (
            <>
              {" "}
              Submission ID: <strong>{submissionId}</strong>
            </>
          )}
        </output>
      )}
      {isError && (
        <p role="alert">
          {errorMessage ?? "The PowerPoint file could not be submitted. The file was not sent. Please try again."}
        </p>
      )}
    </BaseModal>
  );
};

export default PptImportConsentModal;
